<div class="cw-layout">
  <app-workbench-header></app-workbench-header>

  <main class="cw-layout__main" aria-labelledby="unallocated-jobs-title">
    <header class="cw-page-head">
      <div>
        <nav class="cw-breadcrumb" [attr.aria-label]="'unallocated_jobs_title' | translate">
          <a routerLink="/dashboard">{{ "resource_admin_dashboard_title" | translate }}</a>
          <span aria-hidden="true">/</span>
          <span aria-current="page">{{ "unallocated_jobs_title" | translate }}</span>
        </nav>
        <h1 class="cw-page-head__title" id="unallocated-jobs-title">{{ "unallocated_jobs_title" | translate }}</h1>
      </div>
      <div class="cw-thinksafe">
        <img class="cw-thinksafe__logo" src="/assets/thinksafe-logo.png" alt="ThinkSafe" />
        <span class="cw-thinksafe__link">{{ "pending_approval_jobs_health_safety" | translate }}</span>
      </div>
    </header>

    <section class="cw-filters" [attr.aria-label]="'open_jobs_summary_filters' | translate">
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="unallocated-site-name">{{ "unallocated_jobs_filter_site" | translate }}</label>
        <input class="cw-field__control" id="unallocated-site-name" type="search"
          [(ngModel)]="siteName" [placeholder]="'open_jobs_summary_site_name' | translate" />
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="unallocated-brand-name">{{ "open_jobs_summary_filter_brand" | translate }}</label>
        <select class="cw-field__control" id="unallocated-brand-name" [(ngModel)]="brandName">
          <option value="">{{ "open_jobs_summary_show_all" | translate }}</option>
          @for (brand of brands; track brand) {
            <option [value]="brand">{{ brand }}</option>
          }
        </select>
      </div>
    </section>

    <section class="cw-table-card cw-card" [attr.aria-label]="'unallocated_jobs_title' | translate">
      <div class="cw-table-card__scroll">
        <table class="cw-table cw-jobs-table unallocated-jobs-table">
          <thead>
            <tr>
              <th class="cw-table__head-cell unallocated-jobs-table__brand" scope="col">{{ "open_jobs_summary_brand" | translate }}</th>
              <th class="cw-table__head-cell unallocated-jobs-table__site" scope="col">{{ "open_jobs_summary_site" | translate }}</th>
              <th class="cw-table__head-cell cw-jobs-table__id" scope="col">{{ "open_jobs_list_job_id" | translate }}</th>
              <th class="cw-table__head-cell cw-jobs-table__date" scope="col">{{ "open_jobs_list_callout_date" | translate }}</th>
              <th class="cw-table__head-cell" scope="col">{{ "open_jobs_list_fault_service" | translate }}</th>
              <th class="cw-table__head-cell" scope="col">{{ "open_jobs_list_notes" | translate }}</th>
              <th class="cw-table__head-cell cw-jobs-table__work-order" scope="col">{{ "open_jobs_list_work_order" | translate }}</th>
              <th class="cw-table__head-cell cw-jobs-table__actions" scope="col">{{ "unallocated_jobs_actions" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading()) {
              <tr><td class="cw-table__empty" colspan="8" role="status">{{ "signin_lbl_loading_jobs" | translate }}</td></tr>
            } @else if (hasLoadError()) {
              <tr><td class="cw-table__empty" colspan="8" role="alert">{{ "unallocated_jobs_load_failed" | translate }}</td></tr>
            } @else {
            @for (job of filteredJobs; track job.id; let alternate = $odd) {
              <tr class="cw-table__row" [class.cw-job-row--alternate]="alternate">
                <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_summary_brand' | translate"><span>{{ job.brandName || ("open_jobs_summary_not_available" | translate) }}</span></td>
                <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_summary_site' | translate"><span>{{ job.siteName || ("open_jobs_summary_not_available" | translate) }}</span></td>
                <td class="cw-table__cell cw-table__cell--lead" [attr.data-label]="'open_jobs_list_job_id' | translate">{{ job.referenceNumber || ("open_jobs_summary_not_available" | translate) }}</td>
                <td class="cw-table__cell" [attr.data-label]="'open_jobs_list_callout_date' | translate">
                  @if (job.calloutDate) {
                    <time [attr.datetime]="job.calloutDate">{{ job.calloutDate | date: 'dd/MM/yyyy': '+1000' }}<br />{{ job.calloutDate | date: 'hh:mm a': '+1000' }}</time>
                  } @else {
                    {{ "open_jobs_summary_not_available" | translate }}
                  }
                </td>
                <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_fault_service' | translate"><span>{{ job.faultServiceName || ("open_jobs_summary_not_available" | translate) }}</span></td>
                <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_notes' | translate"><span>{{ job.notes || ("open_jobs_summary_not_available" | translate) }}</span></td>
                <td class="cw-table__cell" [attr.data-label]="'open_jobs_list_work_order' | translate">
                  @if (job.workOrderNumber) {
                    <button class="cw-button cw-button--secondary cw-download-button" type="button" (click)="downloadWorkOrder(job)">
                      <mat-icon aria-hidden="true">download</mat-icon>{{ "open_jobs_list_download" | translate }}
                    </button>
                  } @else {
                    {{ "open_jobs_summary_not_available" | translate }}
                  }
                </td>
                <td class="cw-table__cell cw-table__cell--actions" [attr.data-label]="'unallocated_jobs_actions' | translate">
                  <div class="cw-table__actions">
                    <button class="cw-button cw-button--secondary" type="button" [disabled]="!job.companyId" (click)="openAllocateTo(job)">{{ "open_jobs_list_allocate_to" | translate }}</button>
                  </div>
                </td>
              </tr>
            } @empty {
              <tr><td class="cw-table__empty" colspan="8">{{ "open_jobs_summary_empty" | translate }}</td></tr>
            }
            }
          </tbody>
        </table>
      </div>
    </section>
  </main>

  @if (selectedJob) {
    <div class="allocation-backdrop">
      <section class="allocation-dialog" role="dialog" aria-modal="true" aria-labelledby="allocation-dialog-title">
        <header class="allocation-dialog__header">
          <h2 id="allocation-dialog-title">{{ "open_jobs_list_allocate_to" | translate }}</h2>
          <button mat-icon-button type="button" [disabled]="isAllocating" (click)="closeAllocateTo()" [attr.aria-label]="'open_jobs_list_close' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </header>

        <form (ngSubmit)="confirmAllocation()">
          <div class="allocation-dialog__body">
            <mat-radio-group name="allocationMode" [(ngModel)]="allocationMode" [disabled]="isAllocating" (change)="changeAllocationMode()" [attr.aria-label]="'open_jobs_list_allocation_type' | translate">
              <mat-radio-button [value]="AllocationMode.INTERNAL">{{ "open_jobs_list_internal" | translate }}</mat-radio-button>
              <mat-radio-button [value]="AllocationMode.EXTERNAL">{{ "open_jobs_list_external" | translate }}</mat-radio-button>
            </mat-radio-group>

            <mat-form-field appearance="outline">
              <mat-label>{{ "open_jobs_list_email" | translate }}</mat-label>
              <input matInput type="email" name="allocationEmail" [(ngModel)]="allocation.email" (ngModelChange)="changeAllocationEmail()" maxlength="100" required email [disabled]="isAllocating" placeholder="email@email.com">
            </mat-form-field>

            @if (isExternalAllocation) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "open_jobs_list_company_name" | translate }}</mat-label>
                <input matInput type="text" name="allocationCompany" [(ngModel)]="allocation.companyName" minlength="5" maxlength="200" required [disabled]="isAllocating" [matAutocomplete]="companyAutocomplete" [placeholder]="'open_jobs_list_company_name' | translate">
                <mat-autocomplete #companyAutocomplete="matAutocomplete">
                  @for (company of filteredSubconCompanies; track company.id) {
                    <mat-option [value]="company.name">{{ company.name }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>

              @if (hasNoSubconCompanies && !allocation.companyName.trim()) {
                <p class="allocation-dialog__error" role="alert">{{ "open_jobs_list_no_companies" | translate }}</p>
              }
            }

            <div>
              <strong id="allocation-send-work-order-label">{{ "open_jobs_list_send_work_order" | translate }}</strong>
              <mat-radio-group name="sendWorkOrder" [(ngModel)]="allocation.sendWorkOrder"
                [disabled]="isAllocating" aria-labelledby="allocation-send-work-order-label">
                <mat-radio-button [value]="true">{{ "open_jobs_list_yes" | translate }}</mat-radio-button>
                <mat-radio-button [value]="false">{{ "open_jobs_list_no" | translate }}</mat-radio-button>
              </mat-radio-group>
            </div>

            @if (allocationErrorKey) {
              <p class="allocation-dialog__error" role="alert">{{ allocationErrorKey | translate }}</p>
            }
          </div>

          <footer class="allocation-dialog__footer">
            <button mat-stroked-button type="button" [disabled]="isAllocating" (click)="closeAllocateTo()">{{ "open_jobs_list_cancel" | translate }}</button>
            <button mat-raised-button type="submit" [disabled]="!canConfirmAllocation || isAllocating">{{ "open_jobs_list_confirm_allocation" | translate }}</button>
          </footer>
        </form>
      </section>
    </div>
  }
  <app-workbench-footer></app-workbench-footer>
</div>
